import React, { useEffect, useState } from "react";
import CommonDateRangePicker from "../CommonComponent/CommonDateRangePicker";
import { SearchIcon } from "../../../Utils/SvgIcons";
import { getNetworkMenuId, getToken } from "../../../Utils/types";
import { API_URL_WITHOUT_USER } from "../../../Utils/API";
import { GetAdvancePayoutDetails } from "../../../redux/actions/PayoutAction";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import CustomPagination from "../../../common/CustomPagination";

export const PayoutExportToExcel = ({
  setIsExporToExcel,
  setSearchFilter,
  searchFilter,
}) => {
  const [isLoadingExcel, setIsLoadingExcel] = useState(false);
  const globalReducer = useSelector((state) => state?.globalReducer);
  const payoutReducer = useSelector(
    (state) => state?.PayoutReducer?.advancePayoutDetail
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      GetAdvancePayoutDetails({
        ...searchFilter,
        startDate: moment().subtract(15, "days").format("YYYY-MM-DD"),
        endDate: moment(new Date()).format("YYYY-MM-DD"),
      })
    );
  }, []);

  const downloadFile = () => {
    setIsLoadingExcel(true);
    const url = `${API_URL_WITHOUT_USER}/NetworkPayout/ExportToExcelAdvancePayoutNetwork`;
    let data = {
      ...searchFilter,
      IsExportToExcel: true,
    };

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getToken(),
        MenuId: getNetworkMenuId()?.menuId,
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.blob())
      .then((blob) => {
        const filename = "ProviderPayoutDetails.xlsx";
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setIsLoadingExcel(false);
      })
      .catch((error) => {
        console.error("Failed to fetch the file");
        setIsLoadingExcel(false);
      });
  };
  const handleClose = () => {
    setIsExporToExcel(false);
    setSearchFilter({ ...searchFilter, caseNo: "" });
  };
  return (
    <>
      <div
        className="d-flex justify-content-between border-bottom modalHeader"
        style={{ borderRadius: "10px 10px 0px 0px" }}
      >
        <h4 className="font-bold text-black">Advance Payout Details </h4>
        <button
          type="button"
          className="btn-close history-close"
          aria-label="Close"
          onClick={handleClose}
        ></button>
      </div>

      <div
        className="modal-body  addusermodalbox uploadExcelTest  row"
        // style={{ maxHeight: "500px" }}
      >
        <div className="row d-flex gap-1">
          <div className="d-flex col-4">
            <h5 className="col-form-label" style={{ minWidth: "80px" }}>
              Case No.
            </h5>
            <input
              placeholder="Case No "
              value={searchFilter?.caseNo}
              className=" white-form-select  "
              onChange={(e) =>
                setSearchFilter({ ...searchFilter, caseNo: e.target.value })
              }
            />
          </div>
          <div className="w-250 dashbaord-date col-3">
            <CommonDateRangePicker
              searchFilter={searchFilter}
              setSearchFilter={setSearchFilter}
              initialStartDate={new Date().setDate(new Date().getDate() - 15)}
              initialEndDate={new Date()}
            />
          </div>
          <div className="col-2" style={{ width: "130px" }}>
            <button
              className="exortpayout"
              type="button"
              style={{ border: "none" }}
              onClick={() => {
                dispatch(dispatch(GetAdvancePayoutDetails(searchFilter)));
              }}
            >
              <a>
                <SearchIcon />
                &nbsp; &nbsp;&nbsp;
                <span className="sidebar-link-text">Search</span>
              </a>
            </button>
          </div>
          <div className="col-2">
            <button
              className="exortpayout"
              type="button"
              style={{ border: "none" }}
              onClick={downloadFile}
            >
              <a>
                <i className="fa-solid fa-file-csv"></i>&nbsp; &nbsp;&nbsp;
                <span className="sidebar-link-text">Export To Excel</span>
              </a>
            </button>
          </div>
        </div>
      </div>
      <div
        className=" d-flex gap-1"
        style={{
          position: "absolute",
          top: "150px",
          paddingLeft: "16px",
          // width: "100%",
          overflow: "auto",
        }}
      >
        <select
          className="row-selectdropdown"
          value={searchFilter?.rows}
          onChange={(e) => {
            setSearchFilter({ ...searchFilter, rows: e.target.value });
            dispatch(
              dispatch(
                GetAdvancePayoutDetails({
                  ...searchFilter,
                  rows: e.target.value,
                })
              )
            );
          }}
        >
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
        <p className="results">
          Total <span>{globalReducer?.getTotalCount}</span> results
        </p>
      </div>
      <div
        className="table-responsive __custom__properties p-3"
        style={{
          position: "fixed",
          top: "180px",
          maxHeight: "480px",
          width: "100%",
          overflow: "auto",
        }}
      >
        <table className="table">
          <thead>
            <tr className="avanishtbl">
              <th style={{ minWidth: "200px" }}>Case No</th>
              <th style={{ minWidth: "200px" }}> Provider Name</th>
              <th style={{ minWidth: "200px" }}>Client Name</th>
              <th style={{ minWidth: "200px" }}>Customer Name</th>
              <th style={{ minWidth: "150px", textAlign: "center" }}>
                Provider Advance Amount
              </th>
              <th style={{ textAlign: "center", minWidth: "150px" }}>
                Provider Request Status
              </th>
              <th style={{ textAlign: "center", minWidth: "150px" }}>
                {" "}
                Provider Amount
              </th>
              <th style={{ textAlign: "center", minWidth: "150px" }}>UTR</th>
              <th style={{ textAlign: "center", minWidth: "200px" }}>Center</th>
              <th style={{ textAlign: "center", minWidth: "200px" }}>
                Provider Remark
              </th>

              <th style={{ textAlign: "center", minWidth: "200px" }}>
                Provider Document
              </th>
              {searchFilter?.BusinessType === "IBU" && (
                <>
                  <th style={{ textAlign: "center", minWidth: "150px" }}>
                    Insurer Advance Amount
                  </th>
                  <th style={{ textAlign: "center", minWidth: "200px" }}>
                    Insurer Document
                  </th>
                  <th style={{ textAlign: "center", minWidth: "200px" }}>
                    Insurer Home Visit Amount
                  </th>
                  <th style={{ textAlign: "center", minWidth: "200px" }}>
                    Insurer Remark
                  </th>
                  <th style={{ textAlign: "center", minWidth: "200px" }}>
                    Insurer Approver Name
                  </th>
                  <th style={{ textAlign: "center", minWidth: "200px" }}>
                    Insurer Request Status
                  </th>
                </>
              )}
              <th style={{ textAlign: "center", minWidth: "200px" }}>
                Created By
              </th>
              <th style={{ textAlign: "center", minWidth: "200px" }}>
                Created Date
              </th>
            </tr>
          </thead>
          <tbody>
            {payoutReducer?.map((ele, index) => {
              return (
                <tr>
                  <td>{ele?.caseNo}</td>
                  <td>{ele?.providerName}</td>
                  <td>{ele?.clientName}</td>
                  <td>{ele?.proposerName}</td>
                  <td style={{ textAlign: "center" }}>{ele?.advanceAmount}</td>
                  <td style={{ textAlign: "center" }}>{ele?.requestStatus}</td>
                  <td style={{ textAlign: "center" }}>{ele?.refundAmount}</td>
                  <td style={{ textAlign: "center" }}>{ele?.utr}</td>
                  <td style={{ textAlign: "center" }}>{ele?.centreName}</td>
                  <td style={{ textAlign: "center" }}>{ele?.remarks}</td>

                  <td style={{ textAlign: "center" }}>
                    {ele?.filePath && (
                      <a href={ele?.filePath} target="_blank">
                        View Document
                      </a>
                    )}
                  </td>
                  {searchFilter?.BusinessType === "IBU" && (
                    <>
                      <td style={{ textAlign: "center" }}>
                        {ele?.insurerAdvanceAmount}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {ele?.insurerFilePath !== "" && (
                          <a href={ele?.insurerFilePath} target="_blank">
                            View Document
                          </a>
                        )}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {ele?.insurerHomeVisitAmount}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {ele?.insurerRemarks}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {ele?.insurerApproverName}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {ele?.insurerRequestStatus}
                      </td>
                    </>
                  )}
                  <td style={{ textAlign: "center" }}>{ele?.createdBy}</td>
                  <td style={{ textAlign: "center" }}>
                    {moment(ele?.createdDate).format("LLL")}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <div className="d-flex justify-content-center mt-4">
          {globalReducer?.getTotalCount !== 0 && (
            <CustomPagination
              totalCount={globalReducer?.getTotalCount}
              perPageData={searchFilter?.rows}
              searchFilter={searchFilter}
              setSearchFilter={setSearchFilter}
              apiCall={GetAdvancePayoutDetails}
            />
          )}
        </div>
      </div>
    </>
  );
};
